import { getPickupSettings } from '../api/store-api';
import Component from '../classes/component';
import ResizeMonitor from '../classes/resize-monitor';
import Backdrop from './backdrop';
import Calendar from './calendar';

const SELECTORS = {
  toggle: '.toggle',
  popup: '.popup',
  submitButton: '.submit-btn',
};

class PickupSelector extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _resizeMonitor = new ResizeMonitor();

  private get _isCollapsed() {
    return this.container.classList.contains('is-collapsed');
  }

  private _handleToggle() {
    if (this._isCollapsed) {
      this._expandPopup();
      this.container.classList.remove('is-collapsed');
    } else {
      this._collapsePopup();
    }
  }

  private _collapsePopup() {
    const popup = this._getChild('popup');

    const popupHeight = popup.scrollHeight;
    const elementTransition = popup.style.transition;

    popup.style.transition = '';

    requestAnimationFrame(() => {
      popup.style.height = `${popupHeight}px`;
      popup.style.transition = elementTransition;

      requestAnimationFrame(() => {
        popup.style.height = '0px';
      });
    });

    this.container.classList.add('is-collapsed');
    this._getChildComponent<Backdrop>('backdrop').close();
  }

  private _expandPopup() {
    const popup = this._getChild('popup');

    const popupHeight = popup.scrollHeight;
    popup.style.height = `${popupHeight}px`;

    const onTransitionEnd = () => {
      popup.removeEventListener('transitionend', onTransitionEnd);
      popup.style.height = null;
    };

    this.container.classList.remove('is-collapsed');
    this._getChildComponent<Backdrop>('backdrop').open(this._collapsePopup.bind(this));
  }

  private _handleResize() {
    if (!this._isCollapsed) {
      this._collapsePopup();
    }
  }

  private async _fetchSettings() {
    const res = await getPickupSettings();

    if (res.success) {
      this._getChildComponent<Calendar>('calendar').settings = res.data;
    }
  }

  protected _onEnter() {
    this._fetchSettings();

    this._resizeMonitor.addWidthChangeListener(this._handleResize.bind(this));

    this._addListener('toggle', 'click', this._handleToggle);
    this._addListener('submitButton', 'click', this._handleToggle);
  }
}

export default PickupSelector;
